import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { TechnicalConceptAPI } from "../../modules/TechnicalConcept/api/technicalConceptAPI";

const keyQuery = ["ApprovalsTechnicalConcept"];

export const useFetchApprovalsTechnicalConcept = (filters?: any) => {
  return useQuery({
    queryKey: [...keyQuery, filters || {}],
    queryFn: ({ queryKey }) => TechnicalConceptAPI.fetchMovements({ queryKey }),
    enabled: true,
  });
};
